import type { Feature } from 'geojson';

export interface IVlmBlock {
  image_url?: string;
  preview_url?: string;
  vlm_narrative?: string;
  vlm_properties?: Record<string, unknown>;
  vlm_score?: number;
  vlm_label?: string;
  vlm_rationale?: string;
}

export interface VlmRegisteredLayer {
  layerName: string;
  features: Feature[];
}

/**
 * Extracts the VLM data block from a feature regardless of GeoJSON source.
 * - pipeline_vlm.geojson: vlm fields are at the root of properties
 * - pipeline_results.geojson: vlm fields are nested under properties._vlm
 */
export function getVlmBlock(feature: Feature): IVlmBlock | null {
  const p = feature.properties;
  if (!p) return null;
  if (p['vlm_narrative'] !== undefined) return p as IVlmBlock;
  if (p['_vlm']) return p['_vlm'] as IVlmBlock;
  return null;
}
